import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminTools.css";

const AdminSimulation = () => {

    const navigate = useNavigate();

    const [selectedSimulation, setSelectedSimulation] =
        useState("");


    const simulations = [
        {
            id: "astrobee",
            name: "NASA Astrobee",
            description:
                "Edit and build the NASA Astrobee simulation software.",
            language:
                "C++ / Java",
            build_system:
                "CMake / Gradle",
            platform:
                "Linux / ROS",
        },
        {
            id: "intball",
            name: "JAXA Int-Ball",
            description:
                "Edit and build the JAXA Int-Ball simulation software.",
            language:
                "C++ / Java",
            build_system:
                "CMake / Gradle",
            platform:
                "Linux / ROS",
        },
    ];


    const selected = simulations.find(
        (simulation) =>
            simulation.id === selectedSimulation
    );


    const handleEditBuild = () => {

        if (!selectedSimulation) {
            alert(
                "Please select a simulation."
            );

            return;
        }


        navigate(
            `/admin/ide/simulation/${selectedSimulation}`
        );
    };


    return (
        <div className="admin-page">

            {/* HEADER */}

            <header className="admin-page-header">

                <button
                    className="admin-back-button"
                    onClick={() =>
                        navigate("/dashboard")
                    }
                >
                    ← Dashboard
                </button>


                <div>

                    <div className="admin-eyebrow">
                        ADMINISTRATION
                    </div>

                    <h1>
                        Simulation Software
                    </h1>

                    <p>
                        Edit and build space robotics
                        simulation software.
                    </p>

                </div>

            </header>


            {/* CONTENT */}

            <div className="admin-content">

                <div className="admin-panel">

                    <div className="admin-panel-icon">
                        🛰️
                    </div>

                    <h2>
                        Select Simulation
                    </h2>

                    <p>
                        Choose the simulation software
                        you want to edit and build.
                    </p>


                    <label>
                        Simulation Software
                    </label>


                    <select
                        value={selectedSimulation}
                        onChange={(event) =>
                            setSelectedSimulation(
                                event.target.value
                            )
                        }
                        className="admin-select"
                    >

                        <option value="">
                            Select simulation...
                        </option>

                        {simulations.map(
                            (simulation) => (
                                <option
                                    key={simulation.id}
                                    value={simulation.id}
                                >
                                    {simulation.name}
                                </option>
                            )
                        )}

                    </select>


                    {/* SELECTED */}

                    {selected && (

                        <div className="selected-project">

                            <h3>
                                {selected.name}
                            </h3>

                            <p>
                                {selected.description}
                            </p>


                            <div className="project-properties">

                                <div>
                                    <span>
                                        Language
                                    </span>

                                    <strong>
                                        {selected.language}
                                    </strong>
                                </div>


                                <div>
                                    <span>
                                        Build System
                                    </span>

                                    <strong>
                                        {selected.build_system}
                                    </strong>
                                </div>


                                <div>
                                    <span>
                                        Platform
                                    </span>

                                    <strong>
                                        {selected.platform}
                                    </strong>
                                </div>

                            </div>

                        </div>
                    )}


                    <button
                        className="admin-primary-button"
                        onClick={handleEditBuild}
                        disabled={!selectedSimulation}
                    >
                        Edit & Build Simulation
                        <span>→</span>
                    </button>

                </div>


                {/* SIMULATIONS */}

                <div className="supported-projects">

                    <h3>
                        Available Simulations
                    </h3>


                    <div className="supported-grid">

                        <div className="supported-card">

                            <strong>
                                🛰️ Astrobee
                            </strong>

                            <span>
                                NASA Ames Research Center
                            </span>

                        </div>


                        <div className="supported-card">

                            <strong>
                                🤖 Int-Ball
                            </strong>

                            <span>
                                JAXA
                            </span>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default AdminSimulation;